import { useState, useCallback } from "react";
import {
  createNotification,
  cancelNotification,
  type CreateNotificationInput,
} from "../services/notificationService";

export function useCreateNotification() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateNotificationInput) => {
    setLoading(true);
    setError(null);
    try {
      const id = await createNotification(input);
      return id;
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Create notification failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useCancelNotification() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const cancel = useCallback(async (notificationId: string) => {
    setLoading(true);
    setError(null);
    try {
      await cancelNotification(notificationId);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Cancel notification failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { cancel, loading, error };
}
